import React, { useEffect, useState, useCallback } from "react";
import { Table, Typography, Spin, Alert, Button } from "antd";
import axios from "axios";
import dayjs from "dayjs";

const { Title } = Typography;

const CalorieTrackList = ({ refreshSignal }) => { // optionally accept a prop to trigger refresh
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshCount, setRefreshCount] = useState(0);

  // Callback to trigger data reload
  const loadData = useCallback(() => {
    setLoading(true);
    setError(null);
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/calorie-tracking`,
          { withCredentials: true })
      .then((response) => {
        const calperf = response.data;
        calperf[0]["limit"] = calperf[0].bmr + calperf[0].tdee - calperf[0].deficit;
        calperf[0]["limitActivity"] = Math.round(calperf[0].bmr + calperf[0].tdee - calperf[0].deficit + calperf[0].activity);
        calperf[0]["margin"] = Math.round(calperf[0].limitActivity - calperf[0].consumedToday);
        setData(calperf);
      })
      .catch((err) => {
        setError(err.message || "Error fetching data");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Load data on mount and when refreshCount changes
  useEffect(() => {
    loadData();
  }, [loadData, refreshCount]);

  // Refresh when external signal changes (optional)
  useEffect(() => {
    if (refreshSignal !== undefined) {
      loadData();
    }
  }, [refreshSignal, loadData]);

  return (
    <div>
      <Title level={3}>Calorie Tracking</Title>
   
      {loading && <Spin tip="Loading..." />}
      {error && <Alert message="Error" description={error} type="error" showIcon />}
      {!loading && !error && (
        <Table
          dataSource={data}
          columns={columns}
          rowKey={(record) => record.trackdate + record.bmr}
        />
      )}
    </div>
  );
};

const columns = [
    {
      title: "Date",
      dataIndex: "trackdate",
      key: "trackdate",
      render: (date) => dayjs(date).format("YYYY-MM-DD"),
    },
    {
      title: "BMR",
      dataIndex: "bmr",
      key: "bmr",
      sorter: (a, b) => a.bmr - b.bmr,
    },
    {
      title: "TDEE",
      dataIndex: "tdee",
      key: "tdee",
      sorter: (a, b) => a.tdee - b.tdee,
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      sorter: (a, b) => a.activity - b.activity,
    },
    {
      title: "Consumed Today (kcal)",
      dataIndex: "consumedToday",
      key: "consumedToday",
      sorter: (a, b) => a.consumedToday - b.consumedToday,
    },
    {
      title: "Deficit (kcal)",
      dataIndex: "deficit",
      key: "deficit",
      sorter: (a, b) => a.deficit - b.deficit,
    },
    {
      title: "Max Consumable",
      dataIndex: "limitActivity",
      key: "limitActivity",
      sorter: (a, b) => a.deficit - b.deficit,
    },
    {
      title: "Available Calories",
      dataIndex: "margin",
      key: "margin",
      sorter: (a, b) => a.deficit - b.deficit,
    },
  ];

export default CalorieTrackList;
